import { isRecord } from './isRecord';
import { parseJsonColumn } from './parseJsonColumn';
export type WelcomeModalCopy = {
  header?: string;
  subtitle?: string;
  steps?: readonly string[];
  buttonText?: string;
};

export const EMPTY_WELCOME_MODAL_COPY = {
  header: '',
  subtitle: '',
  steps: ['', '', ''],
  buttonText: '',
} as const satisfies WelcomeModalCopy;

const readString = (value: unknown) => (typeof value === 'string' ? value : '');

export const parseWelcomeModalCopy = (rawValue: unknown): WelcomeModalCopy => {
  const parsed = parseJsonColumn(rawValue);

  if (!isRecord(parsed)) {
    return {};
  }

  const copy = parsed as Record<string, unknown>;
  const steps = Array.isArray(copy.steps) ? copy.steps.filter((step): step is string => typeof step === 'string') : [];

  return {
    header: readString(copy.header) || undefined,
    subtitle: readString(copy.subtitle) || undefined,
    steps: steps.length > 0 ? steps : undefined,
    buttonText: readString(copy.buttonText) || undefined,
  };
};
